import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { t } from 'react-switch-lang';
import { observer } from 'mobx-react';
import authStorage from '../../storages/mobx/authStorage';

class HomePage extends Component {
  componentDidMount() {
    const { history } = this.props;
    if (authStorage.isLogged) {
      history.push('/app');
    }
  }

  render() {
    return (
      <div>
        <div className="page-wrapper">
          <div className="container-fluid p-0">
            {/* <!-- login page start--> */}
            <div className="authentication-main">
              <div className="row">
                <div className="col-md-12">
                  <div className="auth-innerright">
                    <div className="authentication-box">
                      <Link to="/app">{t('Go to app')}</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HomePage.propTypes = {};

export default withRouter(observer(HomePage));
